module.exports = __webpack_public_path__ + "static/media/superSmiley.79d74571.svg";